import { StrictLocalizeFunction } from "@faire/web/common/localization";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

import { ITestimonialsData } from "@faire/retailer/components/TestimonialsCardSection/TestinomialsData";

const linebreak = () => <br />;

export const FAIRE_EMPLOYEES = (
  strictLocalize: StrictLocalizeFunction
): readonly ITestimonialsData[] =>
  [
    {
      text: strictLocalize({
        defaultMessage:
          "“We all have a great degree of empathy for our customers, which makes the work feel more tangible and real. Hearing stories about how we’re changing entrepreneurs lives, makes a late night or two totally worth it.”",
      }),
      name: "Zach Grannis",
      info: (
        <StrictLocalMsg
          description={{ text: "Job title and joining date" }}
          defaultMessage="Finance & Strategy Team,<LineBreakFormatting></LineBreakFormatting>at Faire since June 2018"
          values={{ LineBreakFormatting: linebreak }}
        />
      ),
      imageUrl:
        "https://cdn.faire.com/fastly/895d7bb0f03628b180814c3630399d21e6450daaa7574d0e9323c54838ebf14f.png",
    },
    {
      text: strictLocalize({
        defaultMessage:
          "“Working on strategy & analytics at a data-driven company has been so fun and meaningful. I’m doing some of the best work of my life, and feel more challenged than ever. I love the people, the mission, and the team, and my friends and family see that.”",
        description: {
          text: "Employee testimonial for the careers page",
        },
      }),
      name: "Jolie Zwick",
      info: (
        <StrictLocalMsg
          description={{ text: "Job title and joining date" }}
          defaultMessage="Strategy & Analytics Team,<LineBreakFormatting></LineBreakFormatting>at Faire since August 2019"
          values={{ LineBreakFormatting: linebreak }}
        />
      ),
      imageUrl:
        "https://cdn.faire.com/fastly/1332476d250da66de4e19d73007b031fc7721e33cb5cc3705561ee47ad0b26d3.png",
    },
    {
      text: strictLocalize({
        defaultMessage:
          "“We’re still in the early part of our journey at Faire, and there are many challenges to be solved that are not yet defined. Every day, month, and quarter feels like a new adventure.”",
      }),
      name: "Jevin Bhorania",
      info: (
        <StrictLocalMsg
          description={{ text: "Job title and joining date" }}
          defaultMessage="Data Science Team,<LineBreakFormatting></LineBreakFormatting>at Faire since May 2018"
          values={{ LineBreakFormatting: linebreak }}
        />
      ),
      imageUrl:
        "https://cdn.faire.com/fastly/7195021cd50aa4284de9edb2c7afd1d86b7c7fdf910a09b223df17714447b9f2.png",
    },
    {
      text: strictLocalize({
        defaultMessage:
          "“Being an owner at Faire means working together to find solutions for every problem, regardless of whether it falls in your scope or not. There’s no concept of ‘that’s not my job.’ We all have the same goal.”",
      }),
      name: "Nicole Paprocki",
      info: (
        <StrictLocalMsg
          description={{ text: "Job title and joining date" }}
          defaultMessage="Mobile Engineering Team,<LineBreakFormatting></LineBreakFormatting>at Faire since October 2018"
          values={{ LineBreakFormatting: linebreak }}
        />
      ),
      imageUrl:
        "https://cdn.faire.com/fastly/36bd7727cf3f20a637784edd6e9400a4815accbfbcb9d70989265b94c4377ee2.png",
    },
  ] as const;
